import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import BathtubOutlinedIcon from "@mui/icons-material/BathtubOutlined";
import { Divider, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import { AppColors } from "../../../util/AppColors";
import { addIcon } from "../../../util/CommonIconStyle";
import { routeList, statusDrop } from "../../../util/dropList";
import {
  getDayOffsetNumber,
  getTotalEstCostForWorkbook,
} from "../../../util/function";
import CommonClinicPetDetails from "../../CommonScreens/CommonClinicPetDetails/CommonClinicPetDetails";
import UpdateRemarks from "../../CommonScreens/UpdateRemarks/UpdateRemarks";
import PetProcedures from "../ClinicPetDetails/PatientWorkbook/PetProcedures";
import PetTreatmentPlan from "../ClinicPetDetails/PatientWorkbook/PetTreatmentPlan";

const cardIcon = { width: 30, height: 30, color: AppColors.appPrimary };

const initOpenObj = {
  consum: true,
  admin: true,
  pres: true,
  treatmentPlan: true,
  procedures: true,
};

const initProced = { consumList: [], adminList: [], presList: [] };

const GroomPetDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { title, type, appointment } = location.state || {};
  const [isVideoCallEnabled, setVideoCallEnabled] = useState(false);
  const [scrollable, setScrollable] = useState(true);
  const [inpatientId, setInpatientId] = useState(location?.state?.inpatientId);
  const [selectedTab, setSelectedTab] = useState("overView");
  const [allergyModOpen, setAllergyModOpen] = useState(false);
  const [objOpen, setObjOpen] = useState(initOpenObj);
  const [remarksModVsble, setRemarksModVsble] = useState(false);
  const [procedures, setProcedures] = useState([]);
  const [procedValues, setProcedValues] = useState(initProced);
  const [diagList, setDiagList] = useState([]);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { services, clinicStocks, petBilling } = useSelector(
    (state) => state?.clinic
  );
  const appDet = reqDet?.appointment;

  useEffect(() => {
    const reqPrceds = [];
    const reqCons = [];
    const reqAdms = [];
    const reqPresList = [];
    reqDet?.procedures?.forEach((prcd, i) => {
      const reqServ = services?.data?.find(
        (ser) => ser?.serviceId === prcd?.serviceId
      );
      const vnts = getVarinatList(prcd?.serviceId);
      const reqVnt = vnts?.find(
        (vnt) =>
          vnt?.serviceId === prcd?.serviceId && vnt?.name === prcd?.serviceType
      );
      const reqObj = {
        service: {
          name: reqServ?.serviceName,
          value: reqServ?.serviceName,
          serviceId: reqServ?.serviceId,
          category: reqServ?.category,
          subCategory: reqServ?.subCategory,
          remarks: reqServ?.description,
          procedureId: prcd?.procedureId,
        },
        variant: reqVnt,
        procedureId: prcd?.procedureId,
        i,
      };
      reqPrceds.push(reqObj);
      prcd?.procedureDetails?.forEach((det) => {
        const reqStock = clinicStocks?.data?.find(
          (stc) => stc?.stockId === det?.stockId
        );
        const comObj = {
          name: det?.name ?? reqStock?.productName ?? det?.procedureName ?? "",
          procedureName: det?.procedureName,
          stockId: det?.stockId,
          batchId: det?.batchId,
          quantity: det?.quantity,
          detailId: det?.detailId,
          active: det?.active,
          status: det?.status?.length > 0 ? det?.status === "true" : null,
          statusDrop:
            det?.status?.length > 0
              ? det?.status === "true"
                ? statusDrop?.[0]
                : statusDrop?.[1]
              : null,
          reason: det?.remarks?.length > 0 ? det?.remarks : null,
          estCost: det?.estimatedCost,
          delete: false,
          isEdit:
            det?.status === "true" || det?.status === "false" ? false : true,
          deleteable: true,
          serviceId: prcd?.serviceId,
          variantId: reqVnt?.variantId,
          assignToProcedure: {
            name: reqServ?.serviceName,
            serviceId: prcd?.serviceId,
            value: reqServ?.serviceName,
            variantId: reqVnt?.variantId,
          },
          linkToProcedure: reqServ?.serviceName,
        };
        if (det?.type === "Consumables") {
          reqCons.push(comObj);
        }
        if (det?.type === "Administered") {
          const reqBatc = reqStock?.stockBatch?.find(
            (bat) => bat?.batchId === det?.batchId
          );
          const reqAdmObj = {
            ...comObj,
            type: reqStock?.category,
            route: routeList?.find((rl) => rl?.name === det?.route),
            batchNumber: {
              name: reqBatc?.batchNo,
              value: reqBatc?.batchId,
              batchId: reqBatc?.batchId,
              salesUom: reqBatc?.salesUom,
            },
            batchId: det?.batchId,
            duration: "1",
            vaccineType: det?.route,
            dosage: det?.dosage,
          };
          reqAdms.push(reqAdmObj);
        }
      });
    });
    reqDet?.prescription?.[0]?.prescriptionDetails?.forEach((li, i) => {
      const reqObj = {
        ...li,
        detailId: li?.id,
        name: null,
        dosage: li?.dosage,
        duration: li?.duration,
        frequency:
          li?.morning || li?.afternoon || li?.night
            ? [
                li?.morning && "morning",
                li?.afternoon && "afternoon",
                li?.night && "night",
              ]?.filter(Boolean)
            : li?.frequencyDuration?.length > 0
            ? li?.frequencyDuration
            : null,
        customFrequency:
          !li?.morning &&
          !li?.afternoon &&
          !li?.night &&
          li?.frequencyDuration?.length > 0,
        meal: li?.meal,
        plName: li?.name,
        i,
        type: li?.type,
        stockId: li?.stockId,
        qty: li?.quantity,
        isEdit: false,
      };
      reqPresList.push(reqObj);
    });
    setProcedures(reqPrceds);
    setProcedValues({
      ...procedValues,
      consumList:
        reqCons?.length > 0 ? reqCons?.map((cl, i) => ({ ...cl, i })) : [],
      adminList:
        reqAdms?.length > 0 ? reqAdms?.map((al, i) => ({ ...al, i })) : [],
      presList:
        reqPresList?.length > 0
          ? reqPresList?.map((pl, i) => ({ ...pl, i }))
          : [],
    });
  }, [reqDet?.procedures, reqDet?.prescription]);

  useEffect(() => {
    const reqPayment = petBilling?.data?.find(
      (pl) => pl?.appointmentId === appDet?.appointmentId
    );
    if (
      reqPayment?.paymentDetails?.filter((pd) => pd?.type === "diagnostics")
        ?.length > 0
    ) {
      const reqDiagList = reqPayment?.paymentDetails
        ?.filter((pd) => pd?.type === "diagnostics")
        ?.map((dl) => ({ total: dl?.total }));
      setDiagList(reqDiagList);
    }
  }, [petBilling]);

  const getVarinatList = (serId) => {
    if (!serId) return [];
    const reqList = services?.data
      ?.find((ser) => ser?.serviceId === serId)
      ?.serviceVariants?.map((vnt) => ({
        name: vnt?.variantName,
        variantId: vnt?.variantId,
        servicePrice: vnt?.servicePrice,
        value: vnt?.variantName,
        serviceCharge: vnt?.serviceCharge,
        variantNumber: vnt?.variantNumber,
        serviceId: serId,
      }));
    return reqList ?? [];
  };

  const handleObjOpen = (name, value) => {
    setObjOpen({ ...objOpen, [name]: value });
  };

  const onCloseRemarks = () => {
    setRemarksModVsble(false);
  };

  return (
    <>
      <CommonClinicPetDetails
        upcomingVisible={false}
        isVideoCallEnabled={isVideoCallEnabled}
        setVideoCallEnabled={setVideoCallEnabled}
        appointment={appointment}
        scrollable={scrollable}
        setSelectedTab={setSelectedTab}
        setInpatientId={setInpatientId}
        allergyModOpen={allergyModOpen}
        setAllergyModOpen={setAllergyModOpen}
        selectedTab={selectedTab}
        setScrollable={setScrollable}
      >
        <Grid container className="ph2">
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="back-white p10 bs-margin"
          >
            <div className="flex-row">
              <div
                className="ph10pv3"
                onClick={() => setSelectedTab("overView")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "overView"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Overview
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <div className="scroll-80vh">
          <div className="blue-brdr-box">
            <div className="flex-row-ali-cen">
              <div className="w70Per">
                <div className="flex-row-ali-cen">
                  <Typography className="fs14 blue-color font-bold">
                    Case ID - {appDet?.caseId}
                  </Typography>
                  <Typography className="light-blue fs14 txt-semi-bold ml10">
                    {appDet?.serviceType}
                    {appDet?.serviceType === "Consultation"
                      ? ` | ${
                          Array.isArray(appDet?.reason)
                            ? appDet?.reason?.join(", ")
                            : ""
                        }`
                      : ""}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen mt10">
                  <div className="flex-row-ali-cen">
                    <img
                      src={require("../../../assets/images/png/calen.png")}
                      className="img-wh15"
                    />
                    <Typography className="yellow2 fs14 txt-semi-bold ml5">
                      {moment(new Date(appDet?.appointmentDate)).format(
                        "DD MMM YYYY"
                      )}
                    </Typography>
                  </div>
                  {!appDet?.inpatient ? (
                    <div className="flex-row-ali-cen ml10">
                      <img
                        src={require("../../../assets/images/png/clock.png")}
                        className="img-wh15"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {appDet?.appointmentStartTime ??
                          moment(new Date(appDet?.appointmentdateTime)).format(
                            "HH:mm"
                          )}
                      </Typography>
                    </div>
                  ) : null}
                  <div className="flex-row-ali-cen ml10">
                    <img
                      src={require("../../../assets/images/png/steath.png")}
                      className="img-wh20"
                    />
                    <Typography className="yellow2 fs14 txt-semi-bold ml5">
                      {appDet?.doctorName}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen ml10">
                    <BathtubOutlinedIcon sx={addIcon} />
                    {/* <img
                      src={require("../../../assets/images/png/steath.png")}
                      className="img-wh20"
                    /> */}
                    <Typography className="yellow2 fs14 txt-semi-bold ml5">
                      {appDet?.facility}
                    </Typography>
                  </div>
                  {appDet?.inpatient ? (
                    <>
                      <div className="flex-row-ali-cen ml10">
                        <Typography className="blue4 fs12 txt-semi-bold">
                          {reqDet?.inpatient?.facilityType?.toLowerCase() ===
                          "operationtheatre"
                            ? "Opertation Theature : "
                            : "Kennel Number : "}
                        </Typography>
                        <Typography className="gray26 fs12 txt-semi-bold ml5">
                          {reqDet?.inpatient?.kennelNumber ?? ""}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen ml10">
                        <Typography className="blue4 fs12 txt-semi-bold">
                          Outstanding Tasks:
                        </Typography>
                        <Typography className="gray26 fs12 txt-semi-bold ml5">
                          {
                            reqDet?.inpatient?.tasks?.filter(
                              (li) => !li?.status
                            )?.length
                          }
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen ml10">
                        <Typography className="blue4 fs12 txt-semi-bold">
                          No. of Days:
                        </Typography>
                        <Typography className="gray26 fs12 txt-semi-bold ml5">
                          {getDayOffsetNumber(appDet?.appointmentdateTime)}
                        </Typography>
                      </div>
                    </>
                  ) : null}
                </div>

                {!appDet?.inpatient ? (
                  <>
                    <div className="flex-row-ali-cen mt10">
                      <Typography className="card-black1 fs14 txt-semi-bold">
                        Remarks:
                      </Typography>
                      <img
                        src={require("../../../assets/images/png/edit-new.png")}
                        alt=""
                        className="img-wh20 ml10 cursor"
                        onClick={() => setRemarksModVsble(true)}
                      />
                    </div>
                    <Typography className="black fs12 font-medium">
                      {appDet?.remarks}
                    </Typography>
                  </>
                ) : null}
              </div>
              <div className="w30Per">
                <div className="flex1-end">
                  <div>
                    <Typography className="black24 fs14 font-bold">
                      Estimated Cost
                    </Typography>
                    <Typography className="red15 fs26 font-bold">
                      Rs.{" "}
                      {Number(
                        getTotalEstCostForWorkbook(
                          procedures ?? [],
                          procedValues?.consumList ?? [],
                          procedValues?.adminList ?? [],
                          diagList ?? []
                        ) ?? 0
                      )?.toFixed(2)}
                    </Typography>
                    <div className="flex-center">
                      <div className="w60Per">
                        <CustomButton
                          smallBtn
                          text="View"
                          // onClick={handlePaymentView}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Divider className="mv10" />
            {appDet?.inpatient ? (
              <Typography className="yellow-tag white-color font-bold fs12 con-fit">
                Under Treatment
              </Typography>
            ) : null}
            <div className="flex-row-between-align-center">
              <div className="flex-row-ali-cen">
                {reqDet?.lastVisitDate?.length > 0 ? (
                  <div className="flex-row-ali-cen">
                    <Typography className="fs12 blue-color txt-regular">
                      Last Visit:
                    </Typography>
                    <Typography className="ml5 fs12 gray2 font-bold">
                      {moment(new Date(reqDet?.lastVisitDate)).format(
                        "DD, MMM YYYY"
                      )}
                    </Typography>
                  </div>
                ) : null}
                {reqDet?.lastAppointmentId ? (
                  <Typography
                    className="blue-color fs12 txt-semi-bold ml30 underline cursor"
                    //   onClick={handleViewSmmary}
                  >
                    View Summary
                  </Typography>
                ) : null}
              </div>
              {appDet?.appointmentStatus === "consultation" ? (
                <div className="flex-row-ali-cen">
                  <div>
                    <CustomButton
                      text="Finalize"
                      smallBtn
                      // onClick={onFinalize}
                      disabled={appDet?.appointmentStatus !== "consultation"}
                      grayBtn={appDet?.appointmentStatus !== "consultation"}
                    />
                  </div>
                  {/* <div className="ml10">
                      <CustomButton text="Senior Consult" smallBtn yellowBtn />
                    </div> */}
                </div>
              ) : null}
            </div>
          </div>
          <div>
            <div
              className="flex-row-ali-cen cursor mt20"
              onClick={() => handleObjOpen("procedures", !objOpen?.procedures)}
            >
              {objOpen?.procedures ? (
                <ArrowDropDownIcon sx={cardIcon} />
              ) : (
                <ArrowRightIcon sx={cardIcon} />
              )}
              <Typography className="font-bold fs14 blue-color">
                Procedures
              </Typography>
            </div>
            {objOpen?.procedures && <PetProcedures />}
            <div
              className="flex-row-ali-cen cursor mt20"
              onClick={() =>
                handleObjOpen("treatmentPlan", !objOpen?.treatmentPlan)
              }
            >
              {objOpen?.treatmentPlan ? (
                <ArrowDropDownIcon sx={cardIcon} />
              ) : (
                <ArrowRightIcon sx={cardIcon} />
              )}
              <Typography className="font-bold fs14 blue-color">
                Protocol Forms
              </Typography>
            </div>
            {objOpen?.treatmentPlan && <PetTreatmentPlan />}
          </div>
        </div>
      </CommonClinicPetDetails>
      {remarksModVsble ? (
        <UpdateRemarks
          remarksModVsble={remarksModVsble}
          onCloseRemarks={onCloseRemarks}
          remarks={appDet?.remarks}
          notes={appDet?.notes}
          id={appDet?.appointmentId}
        />
      ) : null}
    </>
  );
};

export default GroomPetDetails;
